import React from 'react'
import StandardPage from '@oldscope/ui/components/PageTemplates/StandardPage'
import { string } from 'prop-types'
import { Columns, Column } from '@oldscope/ui/components/Columns'
import { Button } from 'semantic-ui-react'
import StandardPostUI from '../components/ContentfulDataProvider/StandardPostUI'
import MarkdownContent from '../components/MarkdownContent'
import Accordion from '../components/MarkdownAccordion'
import Spacing from '../components/Spacing'
import Link from '../components/Link'
import 'semantic-ui-css/components/button.min.css'
// keep button

const defaultRenderers = {
  Column,
  Columns,
  Accordion,
  Spacing,
  Link: ({ label, ...other }) => (
    <Link {...other}>{label || other.children}</Link>
  ),
  Button,
}

const BasePostFactory = ({ renderers, PageComponent = StandardPage } = {}) => {
  renderers = {
    ...defaultRenderers,
    ...renderers,
  }

  const FullTextComponent = ({ children, ...props }) => (
    <MarkdownContent {...props} content={children} renderers={renderers} />
  )
  const ItemComponent = ({ body, ...fields } = {}) => (
    <PageComponent {...fields} FullTextComponent={FullTextComponent}>
      {body}
    </PageComponent>
  )

  return class BasePost extends React.Component {
    static propTypes = {
      contentType: string,
    }

    static defaultProps = {
      contentType: 'post',
    }

    render() {
      let { match, defaultWhich, which } = this.props
      which = which || match.params.slug || defaultWhich

      return (
        <StandardPostUI
          {...this.props}
          single
          which={which}
          ItemComponent={ItemComponent}
        />
      )
    }
  }
}

export default BasePostFactory
